import { render, staticRenderFns } from "./compreScore.vue?vue&type=template&id=013be3f7&scoped=true"
import script from "./compreScore.vue?vue&type=script&lang=js"
export * from "./compreScore.vue?vue&type=script&lang=js"
import style0 from "./compreScore.vue?vue&type=style&index=0&id=013be3f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013be3f7",
  null
  
)

export default component.exports